import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../continueReport/style.css'
import NavBar from '../../../_components/common/Navbar';
import Footer from '../../../_components/common/Footer';
import ModalNew2 from '../../../_components/common/ModalNew2';
import { Link } from 'react-router-dom'
import { dashBoardAction } from '../../../_actions/dashBoard/dashBoardActions';
import CustomTableNew from '../../../_components/common/CustomTableNew';
import { AlertComp } from '../../../_components/common/AlertComponent/alertComp';
import formData from '../formdata'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import tableColumn from '../tableColumn';
import '../../../_components/common/CustomTableNew/index.css'
import swal from 'sweetalert2';
import Joyride from 'react-joyride';
import Questionnaire from '../../../images/Questionnaire.svg';
import Invite from '../../../images/Invite.svg';
import Lightbulb from '../../../images/Lightbulb.svg';
import { CommonBreadCrumb } from '../../../_components/common/CommonBreadCrumb';
import { LoaderComp } from '../../../_components/common/LoaderComp/Loadercomp';
import Page404 from '../../404page';
import { getAssessementsListAction } from "../../../_actions";


class ContinueReport extends Component {
    constructor(props) {
        super(props);

    }
    state = {
        numberOfQuestion: 0,
        final_assessment_data: this.props.final_assessment_data,
        final_assessment_error: this.props.final_assessment_error,
        hideTable: false,
        invite_modal: false,
        respondentCompleted: true,
        edit_modal: false,
        delete_modal: false,
        send_modal: false,
        summaryTableData: [],
        respondentName: '',
        pathId: null,
        respondant_details: null,
        sellerOrgId: {},
        yet_to_start_count: 0,
        in_progress_count: 0,
        completed_count: 0,
        infoModal: true,
        remainingToExpire: 11,
        loadWholeData: false,
        mandateText: null,
        removeJoyRide: false,


        steps: [
            {
                title: "",
                target: '.panel-one',
                content: (<div style={{ width: '80%' }}><h6>Invite respondents to give you feedback</h6></div>),
                placement: 'bottom',
                locale: { open: "" },
                disableBeacon: true,
                offset: 0
            },
            {
                title: "",
                target: '.fa-pencil-alt',
                content: (<div style={{ width: '80%' }}><h5>Change respondent type, in case you got it wrong</h5><small className="pt-5 required-field">This option is available only for respondents invited by you and not for those allotted by your organization.</small></div>),
                placement: 'right',
                locale: { open: "" },
                offset: 0
            },
            {
                title: "",
                target: '.fa-times',
                content: (<div style={{ width: '80%' }}><h5>Delete the respondent, if you sent it to a wrong individual or email ID</h5><small className="pt-5 required-field">This option is available only for respondents invited by you and not for those allotted by your organization.</small></div>),
                placement: 'bottom',
                locale: { open: "" },
                offset: 0
            },
            {
                title: "",
                target: '.paper-plane',
                content: (<div style={{ width: '80%' }}><h5>Remind the individual to give you feedback</h5>
                </div>),
                placement: 'bottom',
                locale: { open: "" },
                offset: 0
            },
        ],

        adminRespondentsBool: false,

        hasProperId: true,
        idLoader: true
    }

    infoToggle = () => {
        this.setState({
            infoModal: false,

        })
    }

    componentDidMount() {
        const { dispatch, } = this.props;

        let token = localStorage.getItem('access_token')

        dispatch(dashBoardAction.dashBoardAction1(token))

        let reportIdFromPath = this.props.location.pathname.match(/\d/g);
        this.setState({ pathId: reportIdFromPath.join("") })

    }

    componentDidUpdate(prevProps) {
        if (prevProps.final_assessment_error !== this.props.final_assessment_error) {
            this.setState({
                final_assessment_error: this.props.final_assessment_error,
                final_assessment_data: this.props.final_assessment_data
            })
        }

        if (prevProps.getAssessmentData !== this.props.getAssessmentData) {
            if (this.props.getAssessmentData.no_of_questions !== undefined) {
                let numberOfQuestion = this.props.getAssessmentData.no_of_questions

                this.setState({
                    numberOfQuestion
                })
            }
        }

        if (prevProps.dashBoardData !== this.props.dashBoardData) {
            if (this.props.dashBoardData !== '' && this.props.dashBoardData !== undefined) {
                let hasId = false
                this.props.dashBoardData.user_assessments.map(val => {
                    if (this.state.pathId == val.id) {
                        hasId = true


                        let expiryDate2 = new Date(val.expiry_date);
                        let currentDate2 = new Date();
                        let timeDiff2 = expiryDate2.getTime() - currentDate2.getTime();
                        let remainingToExpire = Math.ceil(timeDiff2 / (1000 * 3600 * 24));




                        this.setState({
                            mandateText: val.batch__organisation_mandate_group__assessor_group__assessor_name,
                            loadWholeData: true,
                            remainingToExpire,
                            summaryTableData: val,
                            sellerOrgId: {
                                orgId: val.organisation,
                                sellerId: val.seller
                            }
                        }, () => {
                            let instCountYet = 0
                            let instCountIn = 0
                            let instCountCom = 0
                            let adminRespondentsBool = false

                            this.state.summaryTableData.respondents.map((ob) => {
                                if (ob.assessment_status__status_name == 'Yet to start') {
                                    instCountYet++
                                }
                                if (ob.assessment_status__status_name == 'In progress') {
                                    instCountIn++
                                }
                                if (ob.assessment_status__status_name == 'Completed') {
                                    instCountCom++
                                }

                                if (ob.is_admin_created) {
                                    adminRespondentsBool = true
                                }
                            })

                            this.setState({ adminRespondentsBool, yet_to_start_count: instCountYet, in_progress_count: instCountIn, completed_count: instCountCom }, () => {})
                            const { dispatch } = this.props;
                            dispatch(dashBoardAction.assessorGroupListAction(this.state.sellerOrgId))
                            let data = {}
                            if (val.participant__id !== undefined) {
                                data = {
                                    instrument_id: `${val.instrument__id}`,
                                    is_participant: true,
                                    user_id: val.participant__id,
                                    assessment_id: val.id
                                }
                            } else {
                                data = {
                                    instrument_id: `${val.user_assessment__instrument__id}`,
                                    is_participant: false,
                                    user_id: val.respondent__id,
                                    assessment_id: val.user_assessment__id
                                }
                            }

                            dispatch(getAssessementsListAction.getAssessementsHandler(data))
                            let counterRespCompleted = true
                            this.state.summaryTableData.respondents.map(value => {
                                if (value.respondent__full_name === null || value.respondent__full_name === '') {
                                    value.respondent__full_name = value.respondent__email
                                }
                                if (value.assessment_status__status_name !== "Completed") {
                                    counterRespCompleted = false
                                }
                            })
                            if (!counterRespCompleted) {
                                this.setState({
                                    respondentCompleted: false
                                })
                            }
                            if (val.respondents.length === 0) {
                                this.setState({
                                    steps: [{
                                        title: "",
                                        target: '.panel-one',
                                        content: (<div><h5>Invite respondents to give you a feedback</h5></div>),
                                        placement: 'bottom',
                                        locale: { open: "" },
                                        disableBeacon: true,
                                        offset: 0
                                    }],
                                    respondentCompleted: true
                                })
                            }
                        })
                    }
                })
                this.setState({
                    hasProperId: hasId,
                    idLoader: false
                })
            }
        }
    }

    componentWillReceiveProps(nextProps) {





    }

    toggleInvite(data) {
        this.setState({
            invite_modal: data
        })
    }

    inviteNew(data) {
        const { dispatch } = this.props;
        let removeEmailSpaces = data.email_id.trim();
        let emailArr = removeEmailSpaces.split(',').map(email => email.trim());
    
        const newData = {
            organisation_user_assessement_id: this.state.pathId,
            accessor_group_id: parseInt(data.accessor_group_id, 10),
            email_id: emailArr
        };
    
        dispatch(dashBoardAction.invitePostAction(newData));
    }

    toggleEdit(data) {

        this.setState({
            edit_modal: data
        })
    }


    toggleDelete(data) {
        this.setState({
            delete_modal: data
        })
    }


    toggleSend(data) {
        this.setState({
            send_modal: data
        })
    }

    toggleSendBulk(data) {
        if (this.state.summaryTableData.respondents !== '' && this.state.summaryTableData.respondents !== undefined) {
            if (this.state.summaryTableData.respondents.length !== 0) {
                this.setState({
                    send_modal_bulk: data
                })
            }
        }
    }


    modalOpener(data) {

        this.setState({ respondant_details: data.rowData })
        if (data.buttonType == 'edit') {

            const { assessorGroupList } = this.props;

            let assessor_group_item_id = 0;

            assessorGroupList.organisation_assessor_group_list.map((assessor) => {
                if (data.rowData.assessor_group__id === assessor.assessor_group) {
                    assessor_group_item_id = assessor.id
                }
            })

            formData.Edit.map(val => {
                if (val.key === 'respondent__full_name') {
                    val.value = data.rowData.respondent__full_name
                }
                if (val.key === 'respondent__email') {
                    val.value = data.rowData.respondent__email
                }
                if (val.key === 'accessor_group_id') {
                    val.value = assessor_group_item_id
                }
            })

            this.toggleEdit(true)
        }
        else if (data.buttonType == 'send') {
            this.setState({
                respondentName: data.rowData.respondent__full_name
            }, () => {
                this.toggleSend(true)
            })
        }
        else {
            this.setState({
                respondentName: data.rowData.respondent__full_name
            }, () => {
                this.toggleDelete(true)
            })
        }
    }

    editAction(data) {

        const { dispatch, assessorGroupList } = this.props
        let assessor_groupId = null
        assessorGroupList.organisation_assessor_group_list.map(val => {
            if (val.id === parseInt(data.accessor_group_id, 10)) {

                assessor_groupId = val.assessor_group
            }
        })
        const newData = {
            assessment_id: this.state.summaryTableData.id,
            respondent_id: this.state.respondant_details.id,
            data: {
                accessor_group_id: assessor_groupId
            }
        }


        dispatch(dashBoardAction.editAssesmentAction(newData))

    }

    deleteAction(data) {
        const { dispatch } = this.props

        const newData = {
            user_assessment_id: parseInt(this.state.summaryTableData.id, 10),
            respondent_id: parseInt(this.state.respondant_details.id, 10),
        }

        dispatch(dashBoardAction.removeAssessmentAction(newData))
    }

    sendAction(data) {
        const { dispatch } = this.props

        const newData = {
            assessment_id: parseInt(this.state.summaryTableData.id, 10),
            respondent_id: parseInt(this.state.respondant_details.respondent__id, 10),
        }

        dispatch(dashBoardAction.sendRemainderIndividualAction(newData))
    }

    sendBulkAction(data) {
        const { dispatch } = this.props

        const newData = {
            assessment_id: parseInt(this.state.summaryTableData.id, 10),
        }

        dispatch(dashBoardAction.sendRemainderBulkAction(newData))
    }

    final_assessment_func() {

        const { dispatch } = this.props;
        let data = {
            user_assessment: this.state.summaryTableData.id,
            user: this.state.summaryTableData.participant__id
        }

        dispatch(dashBoardAction.finalAssessments(data, () => {
            swal({
                text: 'Assessment Submitted Successfully',
                type: "success",
                showCancelButton: false,
            }).then(result => {
                if (result['value'] || result['dismiss'] === 'overlay') {
                    this.props.history.push('/app/dashboard')
                }
            })
        }))

    }


    togglefinal_assessment_error() {
        this.setState({
            final_assessment_error: !this.state.final_assessment_error
        })
    }

    calcSubmitBool = () => {
        const countBool = this.state.summaryTableData.respondent_completed >= this.state.summaryTableData.batch__min_respondent;
        const mandateName = this.state.summaryTableData.batch__organisation_mandate_group__assessor_group__assessor_name;

        if (countBool) {
            if (mandateName !== null) {
                let mandateBool = false;

                this.state.summaryTableData.respondents.map(val => {
                    if (mandateName === val.assessor_group__assessor_name) {
                        mandateBool = true;
                    };
                });
                return mandateBool;
            } else {
                return countBool;
            }
        } else {
            return countBool;
        };
    }

    handleJoyrideCallback = (pos) => {
        if (pos.action === 'skip' || pos.action === 'close' || pos.status === 'finished') {
            this.setState({
                removeJoyRide: true
            })
        }
    }


    renderAssessment() {



        tableColumn.summaryTable.map(val => {
            if (val.modalData !== undefined) {
                val.modalData.map(value => {
                    value.modalOpenerFunc = (data) => this.modalOpener(data)

                })
            }
        })



        return (

            <React.Fragment>
                <div className="container">
                    <CommonBreadCrumb
                        data={[
                            {
                                link: '/app/dashboard',
                                name: 'DASHBOARD'
                            },
                            {
                                link: '',
                                name: 'ASSESSMENT'
                            }
                        ]}
                    />
                </div>
                {

                    <div className="animation-fade-in" style={this.state.loadWholeData ? {} : { height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        {
                            this.state.loadWholeData ?

                                <React.Fragment>
                                    {
                                        this.state.summaryTableData.assessment_status__status_name == 'Yet to start' &&
                                        this.state.summaryTableData.instrument__is_multi_rater === true &&
                                        <Modal
                                            isOpen={this.state.infoModal}
                                            centered={true}
                                            style={{ maxWidth: '1000px' }}
                                        >
                                            <ModalHeader
                                                toggle={this.infoToggle} className="bg-black  custom-header" ></ModalHeader>
                                            <ModalBody>
                                                <div className="d-flex flex-row">
                                                    <div className="col-1 px-0">
                                                    </div>
                                                    <div className="col-10 px-0">
                                                        <p className="text-center"><b>{this.state.summaryTableData.instrument__instrument_name} </b>helps you assess yourself and seek feedback from others.</p>
                                                        <div className="d-flex flex-row flex-wrap justify-content-center">
                                                            <div className="col-12 col-md-4 px-0">
                                                                <div className="d-flex flex-row flex-wrap justify-content-center">
                                                                    <div className="col-12 text-center mb-2 px-0">
                                                                        <span className="fa-stack fa-2x">
                                                                            <i className="fas fa-circle text-secondary"></i>
                                                                            <span style={{ fontSize: '16px' }} className="fa-stack-1x text-white">1</span>
                                                                        </span>

                                                                    </div>
                                                                    <div className="col-12 text-center px-0">
                                                                        <img style={{ width: '42%' }} className="img-fluid" src={Questionnaire} />
                                                                    </div>
                                                                    <div className="col-12 mt-2 text-center px-1 text-muted">
                                                                        <h6 className="text-uppercase font-weight-bold">self-assessment</h6>
                                                                        <p style={{ fontSize: '16px' }}>Assess yourself by responding to a set of {this.state.numberOfQuestion} questions. </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-12 col-md-4 px-0">
                                                                <div className="d-flex flex-row flex-wrap justify-content-center">
                                                                    <div className="col-12 text-center mb-2 px-0">
                                                                        <span className="fa-stack fa-2x">
                                                                            <i className="fas fa-circle text-secondary"></i>
                                                                            <span style={{ fontSize: '16px' }} className="fa-stack-1x text-white">2</span>
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-12 text-center px-0">
                                                                        <img style={{ width: '75%' }} className="img-fluid" src={Invite} />
                                                                    </div>
                                                                    <div className="col-12 mt-2 text-center px-1 text-muted">
                                                                        <h6 className="text-uppercase font-weight-bold">respondents</h6>
                                                                        <p style={{ fontSize: '16px' }}>Invite as many people as you like to assess you, and track their progress. Follow up with them, using one-click auto-reminders.</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-12 col-md-4 px-0">
                                                                <div className="d-flex flex-row flex-wrap justify-content-center">
                                                                    <div className="col-12 text-center mb-2 px-0">
                                                                        <span className="fa-stack fa-2x">
                                                                            <i className="fas fa-circle text-secondary"></i>
                                                                            <span style={{ fontSize: '16px' }} className="fa-stack-1x text-white">3</span>
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-12 text-center px-0">
                                                                        <img style={{ width: '40%' }} className="img-fluid" src={Lightbulb} />
                                                                    </div>
                                                                    <div className="col-12 mt-2 text-center px-1 text-muted">
                                                                        <h6 className="text-uppercase font-weight-bold">reports</h6>
                                                                        <p style={{ fontSize: '16px' }}>When you satisfy the minimum respondent criteria, submit your assessment to get your Style-wise and/or 360-degree report (based on what you signed up for)</p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>

                                                    </div>
                                                    <div className="col-1">
                                                    </div>
                                                </div>

                                                <ModalFooter className="justify-content-center pb-0" >
                                                    <button onClick={this.infoToggle} className="bg-green text-white btn-sm " type="submit">OK, GOT IT!</button>
                                                </ModalFooter>
                                            </ModalBody>

                                        </Modal>

                                    }
                                    <div className="container animation-fade-in" >
                                        <div>
                                            <div style={{ display: 'flex', paddingTop: 40, paddingBottom: 20, alignItems: 'center' }}>
                                                <div style={{ flex: 3, flexDirection: 'column', textAlign: 'right' }}>

                                                    <div style={{ flex: 6, justifyContent: 'center', alignItems: 'center' }}>
                                                        <img className="animation-fade-in" src={localStorage.getItem('baseLink') + `/media/` + this.state.summaryTableData.instrument__instrument_image} style={{ width: 80, height: 80 }} />
                                                    </div>

                                                    <div className="progressTab" style={{ flex: 4, justifyContent: 'center', alignItems: 'center' }} >
                                                        <div className={this.state.summaryTableData.is_submited && this.state.summaryTableData.assessment_status__status_name === 'Completed' ? "progressTabGreen" : !this.state.summaryTableData.is_submited && this.state.summaryTableData.assessment_status__status_name === 'Completed' ? 'progressTabYellow' : this.state.summaryTableData.assessment_status__status_name === 'In progress' ? 'progressTabYellow' : 'progressTabRed'} >

                                                        </div>
                                                        <div className={this.state.summaryTableData.is_submited && this.state.summaryTableData.assessment_status__status_name === 'Completed' ? "progressTabGreen" : !this.state.summaryTableData.is_submited && this.state.summaryTableData.assessment_status__status_name === 'Completed' ? 'progressTabYellow' : this.state.summaryTableData.assessment_status__status_name === 'In progress' ? 'progressTabYellow' : 'progressTabWhite progressTabBorderRed'} >

                                                        </div>
                                                        <div className={this.state.summaryTableData.is_submited && this.state.summaryTableData.assessment_status__status_name === 'Completed' ? "progressTabGreen" : !this.state.summaryTableData.is_submited && this.state.summaryTableData.assessment_status__status_name === 'Completed' ? 'progressTabWhite progressTabBorderYellow' : this.state.summaryTableData.assessment_status__status_name === 'In progress' ? 'progressTabWhite progressTabBorderYellow' : 'progressTabWhite progressTabBorderRed'} >

                                                        </div>
                                                    </div>
                                                </div>
                                                <div style={{ flex: 6, paddingLeft: 30, paddingTop: 10 }}>
                                                    <h1>{this.state.summaryTableData.instrument__instrument_name} ASSESSMENT</h1>
                                                    <h3 style={{ color: 'gray', fontSize: 22 }}>{`${this.state.summaryTableData.participant__full_name !== null ? this.state.summaryTableData.participant__full_name : this.state.summaryTableData.participant__email}`.toUpperCase()}'S {this.state.summaryTableData.instrument__instrument_name}</h3>

                                                    {
                                                        this.state.remainingToExpire <= 10 &&
                                                        <AlertComp alertText={this.state.remainingToExpire > 0 ? `Expires in ${this.state.remainingToExpire} day(s)` : this.state.remainingToExpire === 0 ? `EXPIRES TODAY` : `EXPIRED`} />
                                                    }

                                                </div>
                                            </div>

                                            {
                                                this.state.summaryTableData.assessment_status__status_name == 'Yet to start' ?
                                                    <div style={{ paddingTop: 50, borderTopWidth: 0.5, borderLeftWidth: 0, borderRightWidth: 0, borderBottomWidth: 0, borderStyle: 'solid', borderColor: '#b3b3b3' }}>

                                                        <div >
                                                            <p style={{ textAlign: 'center', color: 'gray', fontSize: 22 }}>Complete your self-assessment</p>
                                                        </div>

                                                        <div style={{ textAlign: 'center', paddingBottom: 50 }}>
                                                            <Link to={`/app/dashBoard/continueReport/${this.state.pathId}/assessments`} params={this.state.summaryTableData} onClick={() => window.location.replace(`/app/dashBoard/continueReport/${this.state.pathId}/assessments`)} >
                                                                <button
                                                                    className={
                                                                        "btn btn-red btn-sm text-uppercase"
                                                                    }
                                                                    style={{ margin: '2px', fontSize: '16px', paddingTop: 10, paddingBottom: 10, paddingLeft: 20, paddingRight: 20 }}
                                                                >
                                                                    START
                                                                </button>
                                                            </Link>
                                                        </div>


                                                        {
                                                            this.state.adminRespondentsBool &&
                                                            <div >
                                                                <p style={{ textAlign: 'center', color: 'gray', fontSize: 22 }}>Your organization has invited the following respondents for you. Get their feedback & then submit your assessment.</p>
                                                                <div style={{ borderWidth: 1, borderStyle: 'solid', borderColor: '#666', padding: 20, borderColor: '#dedede' }}>
                                                                    <div style={{ display: 'flex', }}>

                                                                        <div style={{ flex: 7 }}>
                                                                            <p style={{ textAlign: 'center', color: 'gray', fontSize: 18, margin: 0 }}>
                                                                                Optionally, invite more respondents of your choice.
                                                                            </p>
                                                                        </div>

                                                                    </div>

                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            this.state.summaryTableData.instrument__is_multi_rater == true && (this.state.adminRespondentsBool || this.state.summaryTableData.is_self_assessment_completed) ?
                                                                <div style={{ borderWidth: 1, borderStyle: 'solid', marginBottom: 30, marginTop: 30, borderColor: '#dedede' }}>
                                                                    <div style={{ display: 'flex', padding: 10 }}>
                                                                        <div style={{ flex: 1 }}>
                                                                            <p style={{ textAlign: 'center' }}>SUMMARY</p>
                                                                        </div>
                                                                        <div style={{ flex: 1.5, textAlign: 'center' }}>
                                                                            <button
                                                                                onClick={this.toggleInvite.bind(this)}
                                                                                className={
                                                                                    this.state.summaryTableData.is_self_assessment_completed ? "btn btn-red btn-sm text-uppercase  panel-one" : "btn btn-red btn-sm text-uppercase  panel-one disableButtonClass"
                                                                                }
                                                                                style={{ margin: '2px', fontSize: '10px' }}
                                                                            >
                                                                                + Invite Respondents
                                                                            </button>
                                                                        </div>
                                                                        <div style={{ flex: 1.5, flexDirection: 'row' }}>
                                                                            <p style={{ textAlign: 'center' }}><label style={{ backgroundColor: '#1aa388', borderRadius: 10, fontSize: 14, color: "#fff", paddingLeft: 5, paddingRight: 5 }}>{this.state.yet_to_start_count}</label> Yet to start</p>
                                                                        </div>
                                                                        <div style={{ flex: 1.5, flexDirection: 'row' }}>
                                                                            <p style={{ textAlign: 'center' }}><label style={{ backgroundColor: '#1aa388', borderRadius: 10, fontSize: 14, color: "#fff", paddingLeft: 5, paddingRight: 5 }}>{this.state.in_progress_count}</label> In progress</p>
                                                                        </div>
                                                                        <div style={{ flex: 4.5, flexDirection: 'row' }}>
                                                                            <p><label style={{ backgroundColor: '#1aa388', borderRadius: 10, fontSize: 14, color: "#fff", paddingLeft: 5, paddingRight: 5 }}>{this.state.completed_count}</label> Completed</p>
                                                                        </div>
                                                                    </div>
                                                                    <div style={{ backgroundColor: '#b3b3b3', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                        <p style={{ textAlign: 'center', marginBottom: 0, paddingTop: 10, paddingBottom: 10, fontSize: 14, paddingRight: 5, color: "#eee" }}>SEND A REMINDER TO ALL RESPONDENTS WHO HAVEN’T COMPLETED YET</p>
                                                                        <div style={{ backgroundColor: '#eee', borderRadius: 5, paddingLeft: 3, paddingRight: 3 }}><i style={{ cursor: 'pointer' }} className="fas fa-paper-plane" onClick={this.toggleSendBulk.bind(this)}></i></div>
                                                                    </div>
                                                                    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }} onClick={() => this.setState({ hideTable: !this.state.hideTable })}>
                                                                        <p className={"cursor-pointer"} style={{ textDecoration: 'underline', textAlign: 'center', marginBottom: 0 }}>{this.state.hideTable ? 'VIEW ALL' : "HIDE"}</p>
                                                                        <i className={this.state.hideTable ? 'fas fa-chevron-down cursor-pointer' : 'fas fa-chevron-up cursor-pointer'}  ></i>
                                                                    </div>
                                                                    {
                                                                        this.state.hideTable && this.props.assessorGroupList !== '' ?
                                                                            null
                                                                            :
                                                                            <CustomTableNew
                                                                                data={this.state.summaryTableData.respondents !== '' && this.state.summaryTableData.respondents !== undefined ? this.state.summaryTableData.respondents : []}
                                                                                columns={tableColumn.summaryTable}
                                                                                showSlNo="false"
                                                                                modalOpener={this.modalOpener.bind(this)}
                                                                                noPointerClass={true}
                                                                            />
                                                                    }

                                                                </div> :
                                                                null
                                                        }
                                                    </div> :
                                                    <div>
                                                        {this.state.summaryTableData.instrument__is_multi_rater == true ?
                                                            <div>
                                                                <div style={{ borderTopWidth: 1, borderBottomWidth: 0, borderLeftWidth: 0, borderRightWidth: 0, borderStyle: 'solid', borderColor: '#b3b3b3' }}>
                                                                </div>

                                                            </div> :
                                                            null
                                                        }
                                                        {
                                                            this.state.summaryTableData.enable_report == false && this.state.summaryTableData.is_submited == true ?
                                                                <React.Fragment>
                                                                    <div style={{ paddingTop: 30, paddingBottom: 30 }}>
                                                                        <p style={{ textAlign: 'center', color: 'gray', fontSize: 22 }}>Continue answering your questionnaire!</p>
                                                                        <p style={{ textAlign: 'center', color: 'gray', fontSize: 22 }}>You've completed {this.state.summaryTableData.assessment_completed_count} of {this.state.summaryTableData.assessment_number_count} questions.</p>
                                                                    </div>
                                                                    <div style={{ textAlign: 'center' }}>
                                                                        <Link to={`/app/dashBoard`} state={this.state.summaryTableData} onClick={() => window.location.replace(`/app/dashBoard`)}>
                                                                            <button
                                                                                className={
                                                                                    "btn btn-gray btn-sm text-uppercase button-extra-style"
                                                                                }
                                                                                style={{ margin: '2px', fontSize: '16px', paddingTop: 10, paddingBottom: 10, paddingRight: 20, paddingLeft: 20 }}
                                                                            >
                                                                                Go to Dashboard
                                                                            </button>
                                                                        </Link>
                                                                    </div>
                                                                </React.Fragment>
                                                                :
                                                                <React.Fragment>
                                                                    {
                                                                        this.state.summaryTableData.is_self_assessment_completed == true && this.state.summaryTableData.assessment_status__status_name == 'Completed' ?
                                                                            <div>
                                                                                {
                                                                                    this.calcSubmitBool() ?
                                                                                        <div style={{ paddingTop: 10, paddingBottom: 10 }}>
                                                                                            <h3 style={{ textAlign: 'center', color: 'gray', fontSize: 22 }}>You have completed your self-assessment.</h3>


                                                                                            <div style={{ textAlign: 'center', color: 'gray' }}>


                                                                                            </div>
                                                                                            <div style={{ textAlign: 'center', paddingBottom: 20 }}>
                                                                                                <button
                                                                                                    className={
                                                                                                        "btn btn-red btn-sm text-uppercase text-white button-extra-style"
                                                                                                    }
                                                                                                    style={{ margin: '2px', fontSize: '16px', paddingTop: 10, paddingBottom: 10, paddingLeft: 20, paddingRight: 20 }}
                                                                                                    onClick={() => this.final_assessment_func()}
                                                                                                >
                                                                                                    SUBMIT
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>
                                                                                        :
                                                                                        <div style={{ paddingTop: 10, paddingBottom: 10 }}>
                                                                                            <h3 style={{ textAlign: 'center', color: 'gray', fontSize: 22, }}>You have completed your self-assessment.</h3>

                                                                                            <div style={{ textAlign: 'center', color: 'gray' }}>
                                                                                                {
                                                                                                    this.state.mandateText !== null ?
                                                                                                        <p>Now, invite at least {this.state.summaryTableData.batch__min_respondent} respondents and get their feedback. It's mandatory to get feedback from at least one {this.state.mandateText}</p>
                                                                                                        :
                                                                                                        <p>Now, invite at least {this.state.summaryTableData.batch__min_respondent} respondents and get their feedback.</p>
                                                                                                }
                                                                                            </div>


                                                                                        </div>
                                                                                }
                                                                            </div>
                                                                            :
                                                                            <div>
                                                                                <div style={{ paddingTop: 30, paddingBottom: 30 }}>
                                                                                    <p style={{ textAlign: 'center', color: 'gray', fontSize: 22 }}>Continue answering your questionnaire!</p>
                                                                                    <p style={{ textAlign: 'center', color: 'gray', fontSize: 22 }}>You've completed {this.state.summaryTableData.assessment_completed_count} of {this.state.summaryTableData.assessment_number_count} questions.</p>
                                                                                </div>
                                                                                <div style={{ textAlign: 'center' }}>
                                                                                    <Link to={`/app/dashBoard/continueReport/${this.state.pathId}/assessments`} state={this.state.summaryTableData} onClick={() => window.location.replace(`/app/dashBoard/continueReport/${this.state.pathId}/assessments`)}>
                                                                                        <button
                                                                                            className={
                                                                                                "btn btn-red btn-sm text-uppercase button-extra-style"
                                                                                            }
                                                                                            style={{ margin: '2px', fontSize: '16px', paddingTop: 10, paddingBottom: 10, paddingRight: 20, paddingLeft: 20 }}
                                                                                        >
                                                                                            Go to Questionnaire
                                                                                        </button>
                                                                                    </Link>
                                                                                </div>
                                                                            </div>
                                                                    }
                                                                </React.Fragment>
                                                        }
                                                        {
                                                            this.state.summaryTableData.instrument__is_multi_rater == true ?
                                                                <React.Fragment>
                                                                    {
                                                                        this.state.summaryTableData.is_self_assessment_completed && this.state.removeJoyRide === false ?
                                                                            <Joyride
                                                                                continuous
                                                                                showProgress
                                                                                showSkipButton
                                                                                disableScrolling={false}
                                                                                steps={this.state.steps}
                                                                                disableOverlayClose
                                                                                run={true}
                                                                                callback={this.handleJoyrideCallback}
                                                                                disableCloseOnEsc={true}
                                                                                spotlightPadding={0}
                                                                                spotlightClicks={false}
                                                                                styles={{
                                                                                    options: {
                                                                                        width: 320
                                                                                    },
                                                                                    tooltipContent: {
                                                                                        padding: '12px 0px',
                                                                                        display: 'flex',
                                                                                        justifyContent: 'center',
                                                                                        width: '100%'
                                                                                    },
                                                                                    tooltipFooter: {
                                                                                        marginTop: '0px'
                                                                                    },
                                                                                    buttonNext: {
                                                                                        display: this.state.steps.length === 1 ? 'none' : 'block',
                                                                                        padding: '4px'
                                                                                    }
                                                                                }}
                                                                            />
                                                                            :
                                                                            null
                                                                    }
                                                                    <div style={{ borderWidth: 1, borderStyle: 'solid', marginBottom: 30, marginTop: 30, borderColor: '#dedede' }}>
                                                                        <div style={{ display: 'flex', padding: 10 }}>
                                                                            <div style={{ flex: 1 }}>
                                                                                <p style={{ textAlign: 'center' }}>SUMMARY</p>
                                                                            </div>
                                                                            <div style={{ flex: 1.5, textAlign: 'center' }}>
                                                                                <button
                                                                                    onClick={this.toggleInvite.bind(this)}
                                                                                    className={
                                                                                        this.state.summaryTableData.is_self_assessment_completed ? "btn btn-red btn-sm text-uppercase panel-one" : "btn btn-red btn-sm text-uppercase panel-one disableButtonClass"
                                                                                    }
                                                                                    style={{ margin: '2px', fontSize: '10px' }}
                                                                                >
                                                                                    + Invite Respondents
                                                                                </button>
                                                                            </div>
                                                                            <div style={{ flex: 1.5, flexDirection: 'row' }}>
                                                                                <p style={{ textAlign: 'center' }}><label style={{ backgroundColor: '#1aa388', borderRadius: 10, fontSize: 14, color: "#fff", paddingLeft: 5, paddingRight: 5 }}>{this.state.yet_to_start_count}</label> Yet to start</p>
                                                                            </div>
                                                                            <div style={{ flex: 1.5, flexDirection: 'row' }}>
                                                                                <p style={{ textAlign: 'center' }}><label style={{ backgroundColor: '#1aa388', borderRadius: 10, fontSize: 14, color: "#fff", paddingLeft: 5, paddingRight: 5 }}>{this.state.in_progress_count}</label> In progress</p>
                                                                            </div>
                                                                            <div style={{ flex: 4.5, flexDirection: 'row' }}>
                                                                                <p><label style={{ backgroundColor: '#1aa388', borderRadius: 10, fontSize: 14, color: "#fff", paddingLeft: 5, paddingRight: 5 }}>{this.state.completed_count}</label> Completed</p>
                                                                            </div>
                                                                        </div>
                                                                        <div style={{ backgroundColor: '#b3b3b3', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                            <p style={{ textAlign: 'center', marginBottom: 0, paddingTop: 10, paddingBottom: 10, fontSize: 14, paddingRight: 5, color: "#eee" }}>SEND A REMINDER TO ALL RESPONDENTS WHO HAVEN’T COMPLETED YET</p>
                                                                            <div style={{ backgroundColor: '#eee', borderRadius: 5, paddingLeft: 3, paddingRight: 3 }}>
                                                                                {
                                                                                    this.state.respondentCompleted ?
                                                                                        null
                                                                                        :
                                                                                        <i className="fas fa-paper-plane" onClick={this.toggleSendBulk.bind(this)}></i>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }} onClick={() => this.setState({ hideTable: !this.state.hideTable })}>
                                                                            <p className={"cursor-pointer"} style={{ textDecoration: 'underline', textAlign: 'center', marginBottom: 0 }}>{this.state.hideTable ? 'VIEW ALL' : "HIDE"}</p>
                                                                            <i className={this.state.hideTable ? 'fas fa-chevron-down cursor-pointer' : 'fas fa-chevron-up cursor-pointer'}  ></i>
                                                                        </div>

                                                                        {
                                                                            this.state.hideTable ?
                                                                                null
                                                                                :
                                                                                <CustomTableNew
                                                                                    data={this.state.summaryTableData.respondents !== '' && this.state.summaryTableData.respondents !== undefined ? this.state.summaryTableData.respondents : []}
                                                                                    columns={tableColumn.summaryTable}
                                                                                    showSlNo="false"
                                                                                    modalOpener={this.modalOpener.bind(this)}
                                                                                />
                                                                        }
                                                                    </div>

                                                                </React.Fragment>

                                                                :
                                                                <div style={{ paddingBottom: 30 }}>
                                                                </div>
                                                        }

                                                    </div>
                                            }
                                        </div>
                                        {
                                            this.state.invite_modal &&
                                            <ModalNew2
                                                heading="RESPONDENT DETAILS"
                                                showModal={this.state.invite_modal}
                                                formData={formData.continueReport}
                                                selects={['assessor_group__assessor_name']}
                                                action={this.inviteNew.bind(this)}
                                                toggleModal={this.toggleInvite.bind(this)}
                                                viewMessage={[]}
                                                triggerType={"SUBMIT"}
                                                noReset={'noReset'}
                                                selectKey={['id']}
                                            />
                                        }

                                        {
                                            this.state.edit_modal &&
                                            <ModalNew2
                                                heading="EDIT RELATIONSHIP"
                                                showModal={this.state.edit_modal}
                                                formData={formData.Edit}
                                                selects={['assessor_group__assessor_name']}
                                                action={this.editAction.bind(this)}
                                                toggleModal={this.toggleEdit.bind(this)}
                                                viewMessage={[{ text: '' }]}
                                                triggerType={"SUBMIT"}
                                                noReset={'noReset'}
                                                selectKey={['id']}
                                            />
                                        }
                                        {
                                            this.state.delete_modal &&
                                            <ModalNew2
                                                heading="DELETE RESPONDENT"
                                                showModal={this.state.delete_modal}
                                                formData={[]}
                                                action={this.deleteAction.bind(this)}
                                                toggleModal={this.toggleDelete.bind(this)}
                                                viewMessage={[{ text: `Do you want to delete ${this.state.respondentName}` }]}
                                                triggerType={"YES"}
                                            />
                                        }
                                        {
                                            this.state.send_modal &&
                                            <ModalNew2
                                                heading="SEND REMINDER"
                                                showModal={this.state.send_modal}
                                                formData={[]}
                                                action={this.sendAction.bind(this)}
                                                toggleModal={this.toggleSend.bind(this)}
                                                viewMessage={[{ text: `Send a reminder to ${this.state.respondentName}` }]}
                                                triggerType={"SEND MAIL"}
                                            />
                                        }

                                        {
                                            this.state.send_modal_bulk &&
                                            <ModalNew2
                                                heading="SEND REMINDER"
                                                showModal={this.state.send_modal_bulk}
                                                formData={[]}
                                                action={this.sendBulkAction.bind(this)}
                                                toggleModal={this.toggleSendBulk.bind(this)}
                                                viewMessage={[{ text: `Send a reminder to all` }]}
                                                triggerType={"SEND MAIL"}
                                            />
                                        }
                                        {
                                            this.state.final_assessment_error &&
                                            <ModalNew2
                                                heading="Error While Submitting"
                                                showModal={this.state.final_assessment_error}
                                                formData={[]}
                                                epicMessage={{
                                                    status: true,
                                                    stringArr: [this.state.final_assessment_data]
                                                }}
                                                onlyBackButton={true}
                                                toggleModal={this.togglefinal_assessment_error.bind(this)}
                                                viewMessage={[{ text: `` }]}
                                                triggerType={"OK"}
                                            />
                                        }
                                    </div>
                                </React.Fragment>

                                :
                                <LoaderComp color={'black'} />
                        }
                    </div>
                }


            </React.Fragment>

        )
    }

    render() {
        if (!this.props.error) {
            return (
                <div style={{ height: 'calc(100vh - 150px)' }}>
                    <NavBar />
                    {
                        this.state.idLoader ?
                            <div style={{ height: 'calc(100vh - 150px)' }} className="container d-flex justify-content-center">
                                <LoaderComp color={'black'} />
                            </div>
                            :
                            this.state.hasProperId ?
                                <div style={{ minHeight: '100%' }}>
                                    {this.renderAssessment()}
                                </div>
                                :
                                <Page404 unauthorised={true} />
                    }
                    <Footer />
                </div>
            );
        } else {
            return (

                <h1>Something went wrong</h1>
            );
        }

    }
}

function mapStateToProps(state) {


    const { dash_board_data_loading, dash_board_data_error } = state.allotUnallotBatch;
    const dashBoardData = (!dash_board_data_loading && !dash_board_data_error) ? state.dashBoardRed.dash_board_data.data : ''

    const { assessor_group_list_loading, assessor_group_list_error } = state.allotUnallotBatch;
    const assessorGroupList = (!assessor_group_list_loading && !assessor_group_list_error) ? state.AsessorGroupList.assessor_group_list.data : ''


    const { final_assessment_load, final_assessment_error, final_assessment_data } = state.final_assessment_reducer;

    const { getAssessmentLoading } = state.getAssessmentList
    const getAssessmentError = state.getAssessmentList.error
    const getAssessmentData = (!getAssessmentLoading && !getAssessmentError) ? state.getAssessmentList.data.data : {}


    return {

        dashBoardData,
        dash_board_data_loading,
        dash_board_data_error,

        assessor_group_list_loading,
        assessor_group_list_error,
        assessorGroupList,

        final_assessment_error,
        final_assessment_load,
        final_assessment_data,


        getAssessmentData
    };
}

export default connect(mapStateToProps)(ContinueReport);


// WEBPACK FOOTER //
// ./src/_pages/DashBoard/continueReport/continueReport.js